import script from "./TextLink.vue?vue&type=script&setup=true&lang=js"
export * from "./TextLink.vue?vue&type=script&setup=true&lang=js"

import "./TextLink.vue?vue&type=style&index=0&id=0b4db4d6&scoped=true&lang=scss"
script.__scopeId = "data-v-0b4db4d6"

export default script